import { useCallback, useState } from 'react';
import { i18n } from '@lingui/core';
import { Trans, t } from '@lingui/macro';
import _ from 'lodash';
import NgpTwoButtonDialog from '../dialog-two-button/NgpTwoButtonDialog';

const deletePluralText = i18n._(t`Are you sure you want to delete these items?`);
const deleteSingleText = i18n._(t`Are you sure you want to delete this item?`);

export function useDeleteDialog(confirmText) {
    const [open, setOpen] = useState(false);
    const [callbacks, setCallbacks] = useState({
        onDelete: _.noop,
    });
    const showDialog = useCallback((onDelete) => {
        setCallbacks({
            onDelete: () => {
                if (_.isFunction(onDelete)) onDelete();
            },
        });
        setOpen(true);
    }, []);

    const dialog = (
        <DeleteDialog open={open} onConfirm={() => callbacks.onDelete()} setOpen={setOpen} confirmText={confirmText} />
    );

    return [dialog, showDialog];
}

function DeleteDialog({ plural, open, setOpen, onConfirm, confirmText }) {
    const standardText = plural ? deletePluralText : deleteSingleText;
    const theConfirmText = confirmText || standardText;

    return (
        <NgpTwoButtonDialog
            title={<Trans>Confirm Delete</Trans>}
            confirmButtonText={<Trans>Delete</Trans>}
            cancelButtonText={<Trans>Cancel</Trans>}
            open={open}
            setOpen={setOpen}
            onConfirm={onConfirm}
            isWarning
            closeInTitleBar={false}
        >
            <div>{theConfirmText}</div>
        </NgpTwoButtonDialog>
    );
}

export default DeleteDialog;
